import {createPromisedAction} from '/util/action.util';

export const CONTINUE_SEQUENCE: string = 'LAUNCH_SEQUENCE/CONTINUE';
export const COMPLETE_STEP: string = 'LAUNCH_SEQUENCE/COMPLETE_STEP';
export const COMPLETE: string = 'LAUNCH_SEQUENCE/COMPLETE';

export const continueSequence = createPromisedAction(CONTINUE_SEQUENCE);

export const completeStep = createPromisedAction(COMPLETE_STEP, ['stepName']);

export const complete = createPromisedAction(COMPLETE);
